import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../styles/LoginForm.css';

interface LoginFormProps {
  onSubmit: (email: string, password: string) => void;
  isLoading?: boolean;
  error?: string;
  onLoginAttempt?: (email: string, success: boolean) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, isLoading = false, error: externalError, onLoginAttempt }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Simple validation
    if (!email.trim() || !password.trim()) {
      setError(t('login.error.emptyFields') || 'Please enter both email and password');
      return;
    }

    // Basic email validation
    if (!email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setError('');
    
    onSubmit(email, password);
  };

  const displayError = externalError || error;

  return (
    <div className="login-container">
      <div className="login-form-wrapper">
        <div className="login-header">
          <div className="logo-bg">
            <img src="https://infrasec.se/wp-content/uploads/2024/09/Infrasec_lockup_01@4x.png" alt="Infrasec" className="logo" />
          </div>
          <h1>{t('login.title')}</h1>
          <p>{t('login.subtitle')}</p>
        </div>
        
        {displayError && <div className="error-message">{displayError}</div>}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">{t('login.email') || 'Email'}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('login.emailPrompt') || 'Enter your email'}
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">{t('login.password')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('login.passwordPrompt') || 'Enter your password'}
              disabled={isLoading}
            />
          </div>
          
          <div className="form-actions">
            <button 
              type="submit" 
              className="login-button" 
              disabled={isLoading}
            >
              {isLoading ? t('login.loggingIn') : t('login.loginButton')}
            </button>
          </div>
          
          <div className="form-footer">
            <Link to="/forgot-password" className="forgot-password">
              {t('login.forgotPassword')}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;